import {Store, useStore} from 'vuex';
import {StoreHours} from '../types';
import {computed} from 'vue';

export function useStoreHours() {

    const store: Store<StoreHours> = useStore();
    const storeHours = computed<StoreHours[]>(() => store.getters['storeHours/storeHours']);

    const getTodaysHours = () => {
        const currentTime = (new Date);
        return Object.values(storeHours.value).find((storeHour) =>
            storeHour.day === ((currentTime.getDay() + 6) % 7),
        );
    };

    const isCurrentlyOpen = () => {

        const todayHours = getTodaysHours();
        if(!todayHours.isOpen) { return false; }

        const closeTime = (new Date);
        closeTime.setHours(Number(todayHours.closeTime.split(':')[0]), Number(todayHours.closeTime.split(':')[1]));

        const openTime = (new Date);
        openTime.setHours(Number(todayHours.openTime.split(':')[0]), Number(todayHours.openTime.split(':')[1]));

        const currentTime = (new Date);
        return openTime <= currentTime && currentTime < closeTime;
    };

    return {
        storeHours,
        isCurrentlyOpen,
        getTodaysHours,
    };
}
